import { Component, OnInit, EventEmitter } from "@angular/core";
import {
  UploadFile,
  UploaderOptions,
  UploadInput,
  humanizeBytes,
  UploadOutput,
} from "ngx-uploader";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { Sharedservice } from "src/app/shared-components/shared.service";
// tslint:disable-next-line:max-line-length
import {
  severitymessage,
  DownloadUploadFlatfileComponentmessage,
  FunctionalityNames,
  LanguageConstants,
} from "../../shared-components/constant";
import { FlatfileService } from "src/app/services/flatfile.service";
import { saveAs } from "file-saver";
import { EngagementService } from "src/app/services/engagement.service";
import { ErrorPopUpModel } from "../../models/errorpopup.model";
import { AuditingService } from "src/app/services/auditing.service";
import { WebJobQueueService } from "src/app/services/webjobqueue.service";
import { WebJobQueueModel } from "src/app/models/webJobQueue.model";
import { InfraService } from "src/app/services/infra.service";
import { PeriodService } from "src/app/services/period.service";
import { EngagementModel } from "src/app/models/engagement.model";
import { AccountingCalendarEnum } from "src/app/enums/accounting-calendar.enum";
import { PeriodPreferenceModel } from "src/app/models/period-preference.model";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";
@Component({
  selector: "app-download-upload-flatfile",
  templateUrl: "./download-upload-flatfile.component.html",
  styleUrls: ["./download-upload-flatfile.component.css"],
})
export class DownloadUploadFlatfileComponent implements OnInit {
  options: UploaderOptions;
  sourceFiles: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  loadspinner = false;
  configUrl: string;
  engagementId: number;
  flatFileStepId: number;
  buttonText = "Download flat file template";
  downloadFlatFileBtnDisabled = true;
  isEngagementReadOnly: boolean = false;
  flatfile: any;
  flatfileName = "";
  loadspinnerflatfile = false;
  private flatFileTemplateDownloadUrl: string;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  showNextButton = false;
  missingSmPartialRows = false;
  missingSmAllRows = false;
  smSuccess = false;
  isPnP: boolean;
  public templateId: number;
  isTempFlatfileUploaded: number;
  selectedRegionId: number;
  private maxsize = environment.maxFileSize * 1024 * 1024;
  private maxFlatFileSizeUploadLimit =
    environment.maxFlatFileSizeUploadLimit * 1024 * 1024;
  private minFlatFileSizeToSendEmail = environment.minFlatFileSizeToSendEmail;
  timeOutHandler: NodeJS.Timer;
  timeOutHandlerFlatFileDownload: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  isTimeIntervalInProgressFlatFileDownload = false;
  webJobQueueId: number;
  flatFileDownloadWebJobQueueId: number;
  uploadedFlatFileName = "";
  show = false;
  notificationDisplay = false;
  isFlatFileTemplatePopupVisible = false;
  isDatesInRowFormat = false;
  isEndDateMismatch = false;
  accountingCalendarId = 0;
  endDateBasedOnTemplate = "0";
  nextStep: any;
  previousStep: any;
  langCode: string;
  currLangTranslation: any;
  isFlatFileDownload: boolean = false;
  isFlatFileUploaded:boolean = false;
  isCustomizedEngagement: boolean = false;
  constructor(
    private infraService: InfraService,
    private route: ActivatedRoute,
    private appConfigService: AppConfigurationService,
    private messageService: MessageService,
    public router: Router,
    public sharedService: Sharedservice,
    private flatFileService: FlatfileService,
    private engagementservice: EngagementService,
    private auditingService: AuditingService,
    private webJobQueueService: WebJobQueueService,
    private periodService: PeriodService,
    private translateService: TranslateService
  ) {
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ],
    };

    this.engagementId = +this.route.snapshot.paramMap.get("id");

    this.infraService.infraDetails$.subscribe((data) => {
      this.selectedRegionId = data.InfraId;
      this.configUrl = data.WebEndPoint2 + "flatfile/AddFlatFileToQueue/";
      this.flatFileTemplateDownloadUrl =
        data.WebEndPoint2 + "filedownload/template/" + this.engagementId;
    });

    this.sourceFiles = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
    this.flatFileStepId = 1;
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;

    this.getEngagementDetails();
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.isTempFlatfileUploaded = this.sharedService.getLocalStorageValueByName(
      "isTempFlatfileUploaded" + this.engagementId + this.selectedRegionId
    );
    this.showNextButton = this.isTempFlatfileUploaded === 1 ? true : false;

    if (
      this.engagementservice.engModel.IsPnP &&
      this.engagementservice.engModel.TemplateId != 3 && this.engagementservice.engModel.AccCalendarId === 1
    )
      this.sharedService.setactiveindex(1);

    else {this.sharedService.setactiveindex(0);}
    this.flatFileService
      .getflatfilestatus(this.engagementId)
      .subscribe((data) => {
        this.flatfile = data["totalcount"];
        if (this.flatfile >= 1) {
          this.buttonText = this.currLangTranslation.step7.btnDownloadFlatfile; //'Download flat file';
          this.isFlatFileDownload = true;
        } else {
          this.buttonText =
            this.currLangTranslation.step4.downloadFlatFileTemplateBtn; //'Download flat file template';
        }
        this.downloadFlatFileBtnDisabled = false;
      });

    if (this.route.snapshot.paramMap.get("src") === "assessment") {
      window.location.href = this.flatFileTemplateDownloadUrl;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.info,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.downloadUploadFlatfileComponentmessage
            .ErrorMessage.DownloadFlatFileInfo,
        life: 10000,
      });
    }
    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        if (this.flatfile >= 1) {
          this.buttonText = this.currLangTranslation.step7.btnDownloadFlatfile; //'Download flat file';
        } else {
          this.buttonText =
            this.currLangTranslation.step4.downloadFlatFileTemplateBtn; //'Download flat file template';
        }
      }
    );
  }

  getEngagementDetails() {
    this.engagementservice
      .getEngagement(this.engagementId)
      .subscribe((resp: EngagementModel) => {
        this.accountingCalendarId = resp.AccCalendarId;
        this.isFlatFileUploaded = resp.IsFlatfileTemplateUploaded;
        this.isCustomizedEngagement = resp.IsCustomizedEngagement;
        if (
          (this.accountingCalendarId === AccountingCalendarEnum.P445 ||
            this.accountingCalendarId === AccountingCalendarEnum.P454 ||
            this.accountingCalendarId === AccountingCalendarEnum.P544) &&
          resp.IsPreferredSourceEndDate === null &&
          resp.IsFlatfileTemplateUploaded
        ) {
          this.periodService
            .IsEndDateMismatchExist(this.engagementId)
            .subscribe((periodResp) => {
              if (periodResp) {
                this.isEndDateMismatch = true;
              }
            });
        }

        this.isPnP = resp.IsPnP;
        this.templateId=resp.TemplateId;
      });
  }

  showFlatFileTemplatePopup() {
    if (!this.isFlatFileDownload) {
      // show download flat file template popup
      this.isFlatFileTemplatePopupVisible = true;
    } else {
      this.startDownloadFlatFile();
    }
  }

  downloadFlatFileTemplate(isDatesInRowFormat: boolean) {
    this.isFlatFileTemplatePopupVisible = false;

    this.loadspinnerflatfile = true;
    this.isDatesInRowFormat = isDatesInRowFormat;

    this.flatFileService
      .getflatfileTemplate(this.engagementId, this.isDatesInRowFormat)
      .subscribe(
        (blobData) => {
          this.loadspinnerflatfile = false;
          if (blobData) {
            saveAs(
              blobData,
              this.currLangTranslation.step1.flatfileTemplateName + ".xlsx"
            );
          } else {
            this.loadspinnerflatfile = false;

            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary:
                this.currLangTranslation.downloadUploadFlatfileComponentmessage
                  .ErrorMessage.DownloadFlatFileTemplateSummary,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;

          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary:
              this.currLangTranslation.downloadUploadFlatfileComponentmessage
                .ErrorMessage.DownloadFlatFileTemplateSummary,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  startDownloadFlatFile() {
    this.loadspinnerflatfile = true;
    // Add into Queue
    this.flatFileService
      .addFlatFileDownloadIntoQueue(this.engagementId, true)
      .subscribe((queueId: any) => {
        this.flatFileDownloadWebJobQueueId = queueId.id;
        this.checkFlatFileDownloadProcessed();
      });
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (!this.isEngagementReadOnly) {
      if (output.type === "allAddedToQueue") {
        // when all files added in queue uncomment this if you want to auto upload files when added.
        if (this.sourceFiles.length > 1) {
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.severitymessage.MutiFileUploadError;
          this.sourceFiles = [];
        } else if (this.sourceFiles.length == 1) {
          this.uploadedFlatFileName = this.sourceFiles[0].name;
          const event: UploadInput = {
            type: "uploadAll",
            url:
              this.configUrl + `${this.engagementId}\\${this.flatFileStepId}`,
            method: "POST",
            // tslint:disable-next-line:max-line-length
            headers: {
              Authorization:
                "Bearer " +
                (environment.isBearerAuthorizationEnabled
                  ? localStorage["dbamsaltoken"]
                  : environment.sampleToken),
            },
          };
          this.uploadInput.emit(event);
        }
      } else if (
        output.type === "addedToQueue" &&
        typeof output.file !== "undefined"
      ) {
        // add file to array when added
        if (output.file.size > this.maxFlatFileSizeUploadLimit) {
          this.loadspinner = false;
          fileInput.value = "";
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.severitymessage.MaxsizeError +
            " " +
            output.file.name +
            "  " +
            " of size more than " +
            environment.maxFlatFileSizeUploadLimit +
            " MB";
        } else {
          this.sourceFiles.push(output.file);
        }
      } else if (
        output.type === "uploading" &&
        typeof output.file !== "undefined"
      ) {
        this.loadspinner = true;
        // update current data in files array for uploading file
        const index = this.sourceFiles.findIndex(
          (file) =>
            typeof output.file !== "undefined" && file.id === output.file.id
        );
        this.sourceFiles[index] = output.file;
      } else if (output.type === "done" && typeof output.file !== "undefined") {
        if (
          output.file &&
          output.file.response &&
          output.file.response.message === "Invalid File Format"
        ) {
          this.loadspinner = false;
          fileInput.value = "";
          this.uploadInput.emit({ type: "remove", id: output.file.id });
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
          return;
        }

        if (this.sourceFiles[0].responseStatus == 400) {
          if (this.sourceFiles[0].response.statusId === 422) {
            // 422 status id means queue is already present for flatfileupload
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.headerTitle =
              this.currLangTranslation.severitymessage.notification;
            this.errorModel.displayMessage =
              this.currLangTranslation.downloadUploadFlatfileComponentmessage.ErrorMessage.QueueInProgress;
            this.loadspinner = false;
          } else {
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.FormateError,
              sticky: true,
              closable: true,
            });
          }
        } else {
          if (this.sourceFiles[0].response.status === severitymessage.success) {
            this.webJobQueueId = this.sourceFiles[0].response.id;
            this.auditingService
              .addAudit(this.engagementId, FunctionalityNames.UploadFlatFile)
              .subscribe();
            //if ((((this.sourceFiles[0].size) / 1024) >= this.minFlatFileSizeToSendEmail)) {
            this.loadspinner = false;
            this.notificationDisplay = true;
            this.isFlatFileProcessed();
            //} else {
            //  this.webJobQueueId = this.sourceFiles[0].response.id;
            //  this.checkFlatFileProcessed();
            //}
          } else if (
            this.sourceFiles[0].response.message &&
            this.sourceFiles[0].response.message !== ""
          ) {
            this.loadspinner = false;
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.displayMessage =
              this.sourceFiles[0].response.message;
          } else {
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        }
        this.sourceFiles = [];
        // Clear file - to upload same file name twice
        fileInput.value = "";
      } else if (
        output.type === "rejected" &&
        typeof output.file !== "undefined"
      ) {
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
        fileInput.value = "";
        this.loadspinner = false;
      } else if (output.type === "removed") {
        // remove file from array when removed
        this.sourceFiles = this.sourceFiles.filter(
          (file: UploadFile) => file !== output.file
        );
        this.loadspinner = false;
      } else if (output.type === "dragOver") {
        this.dragOver = true;
      } else if (output.type === "dragOut") {
        this.dragOver = false;
      } else if (output.type === "drop") {
        this.dragOver = false;
      }
    }
  }

  isFlatFileProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.loadspinner = false;
            this.isTimeIntervalInProgress = false;
            clearInterval(this.timeOutHandler);
            if (resp.isError) {
              if (resp.responseText === "") {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              } else {
                // Displays multiple validation msgs
                //  this.errorModel.confirmIsDisplay = true;
                //this.errorModel.displayMessage = resp.responseText.split('@@');
              }
            } else {
              this.UpdateEngagementFlatfileUploaded();
              if (resp.isSMMissingAllRows) {
                this.missingSmAllRows = true;
              } else if (!resp.isSMMissingAllRows && resp.isSMMissing) {
                this.missingSmPartialRows = true;
              } else {
                this.smSuccess = true;
                // Bug: 2305283 - After uploading flatfile successfully, clicking on the "Download Flat File" should hide flatfile template pop-up.
                this.isFlatFileDownload = true;
              }
              const rowsUploadedMsg =
                resp.noOfRowsUploaded +
                " " +
                this.currLangTranslation.downloadUploadFlatfileComponentmessage
                  .SuccessMessage.RowsUploaded;
              //this.messageService.add({
              //  key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success,
              //  summary: this.currLangTranslation.severitymessage.notification, detail: rowsUploadedMsg, sticky: true, closable: true
              //});

              this.buttonText =
                this.currLangTranslation.step7.btnDownloadFlatfile; //'Download flat file';
              this.engagementservice
                .updateEngagementStepId(this.engagementId, 0)
                .subscribe();

              if (
                this.accountingCalendarId === AccountingCalendarEnum.P445 ||
                this.accountingCalendarId === AccountingCalendarEnum.P454 ||
                this.accountingCalendarId === AccountingCalendarEnum.P544
              ) {
                this.periodService
                  .IsEndDateMismatchExist(this.engagementId)
                  .subscribe(
                    (periodResp) => {
                      if (periodResp) {
                        this.isEndDateMismatch = true;
                        this.endDateBasedOnTemplate = "0";
                      } else {
                        this.showNextButton = true;
                      }
                    },
                    (err) => {
                      this.loadspinner = false;
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.error,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.severitymessage
                            .somethingwrong,
                        sticky: true,
                        closable: true,
                      });
                    }
                  );
              } else {
                this.showNextButton = true;
              }
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinner = true;
                this.isFlatFileProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinner = true;
              this.isFlatFileProcessed();
            }, environment.webjobTimer);
          }
        }
      },
      (err) => {
        this.loadspinner = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  checkFlatFileProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.loadspinner = false;
            this.isTimeIntervalInProgress = false;
            clearInterval(this.timeOutHandler);
            if (resp.isError) {
              if (resp.responseText === "") {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              } else {
                // Displays multiple validation msgs
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = resp.responseText.split("@@");
              }
            } else {
              this.UpdateEngagementFlatfileUploaded();
              if (resp.isSMMissingAllRows) {
                this.missingSmAllRows = true;
              } else if (!resp.isSMMissingAllRows && resp.isSMMissing) {
                this.missingSmPartialRows = true;
              } else {
                this.smSuccess = true;
                // Bug: 2305283 - After uploading flatfile successfully, clicking on the "Download Flat File" should hide flatfile template pop-up.
                this.isFlatFileDownload = true;
              }
              const rowsUploadedMsg =
                resp.noOfRowsUploaded +
                " " +
                this.currLangTranslation.downloadUploadFlatfileComponentmessage
                  .SuccessMessage.RowsUploaded;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.success,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: rowsUploadedMsg,
                sticky: true,
                closable: true,
              });

              this.buttonText =
                this.currLangTranslation.step7.btnDownloadFlatfile; //'Download flat file';
              this.engagementservice
                .updateEngagementStepId(this.engagementId, 0)
                .subscribe();

              if (
                this.accountingCalendarId === AccountingCalendarEnum.P445 ||
                this.accountingCalendarId === AccountingCalendarEnum.P454 ||
                this.accountingCalendarId === AccountingCalendarEnum.P544
              ) {
                this.periodService
                  .IsEndDateMismatchExist(this.engagementId)
                  .subscribe(
                    (periodResp) => {
                      if (periodResp) {
                        this.isEndDateMismatch = true;
                        this.endDateBasedOnTemplate = "0";
                      } else {
                        this.showNextButton = true;
                      }
                    },
                    (err) => {
                      this.loadspinner = false;
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.error,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.severitymessage
                            .somethingwrong,
                        sticky: true,
                        closable: true,
                      });
                    }
                  );
              } else {
                this.showNextButton = true;
              }
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinner = true;
                this.checkFlatFileProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinner = true;
              this.checkFlatFileProcessed();
            }, environment.webjobTimer);
          }
        }
      },
      (err) => {
        this.loadspinner = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  checkFlatFileDownloadProcessed() {
    this.webJobQueueService
      .getWebJobQueue(this.flatFileDownloadWebJobQueueId)
      .subscribe(
        (resp: WebJobQueueModel) => {
          if (resp) {
            if (!resp.isQueued) {
              this.isTimeIntervalInProgressFlatFileDownload = false;
              clearInterval(this.timeOutHandlerFlatFileDownload);

              if (resp.isError) {
                this.loadspinnerflatfile = false;

                if (resp.responseText === "") {
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                } else {
                  this.errorModel.confirmIsDisplay = true;
                  this.errorModel.displayMessage = resp.responseText;
                }
              } else {
                this.downloadFlatFile();
              }
            } else {
              if (!this.isTimeIntervalInProgressFlatFileDownload) {
                this.timeOutHandlerFlatFileDownload = setInterval(() => {
                  this.isTimeIntervalInProgressFlatFileDownload = true;
                  this.loadspinnerflatfile = true;
                  this.checkFlatFileDownloadProcessed();
                }, environment.webjobTimer);
              }
            }
          } else {
            this.loadspinnerflatfile = false;
            this.isTimeIntervalInProgressFlatFileDownload = false;
            clearInterval(this.timeOutHandlerFlatFileDownload);
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;
          this.isTimeIntervalInProgressFlatFileDownload = false;
          clearInterval(this.timeOutHandlerFlatFileDownload);
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadFlatFile() {
    this.loadspinnerflatfile = true;

    this.engagementservice
      .getEngagement(this.engagementId)
      .subscribe((data) => {
        if (data !== null) {
          this.flatfileName = data.EngagementName; // "{0}_FlateFile_{1}.xlsx";

          const today = new Date();
          let todayDateString;

          if (data.RegionId === 1) {
            todayDateString =
              ("0" + (today.getMonth() + 1)).slice(-2) +
              ("0" + today.getDate()).slice(-2) +
              today.getFullYear();
            this.flatfileName += "_FlatFile_" + `${todayDateString}.xlsx`;
          } else {
            todayDateString =
              ("0" + today.getDate()).slice(-2) +
              ("0" + (today.getMonth() + 1)).slice(-2) +
              today.getFullYear();
            this.flatfileName += "_FlatFile_" + `${todayDateString}.xlsx`;
          }

          this.flatFileService
            .getflatfile(this.flatFileDownloadWebJobQueueId)
            .subscribe(
              (blobData) => {
                this.loadspinnerflatfile = false;
                if (blobData) {
                  saveAs(blobData, this.flatfileName);
                } else {
                  this.loadspinnerflatfile = false;

                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                }
              },
              (err) => {
                this.loadspinnerflatfile = false;

                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              }
            );
        } else {
          this.loadspinnerflatfile = false;

          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      });
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: "cancel", id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: "remove", id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: "removeAll" });
  }

  confirmdisplay = false;
  closeEventFlatFile($event) {
    this.confirmdisplay = $event;
  }

  UpdateEngagementFlatfileUploaded() {
    if (this.isTempFlatfileUploaded !== 1) {
      localStorage.setItem(
        "isTempFlatfileUploaded" + this.engagementId + this.selectedRegionId,
        "1"
      );
    }
  }

  next() {
    this.messageService.clear();
    // If std mapping is provided for few rows - trigger automated mapping & find std mapping for missing
    // rows - redirect user to Verification screen
    // If std mapping is provided for all rows - redirect user to Verification screen
    this.engagementservice
      .getEngagement(this.engagementId)
      .subscribe((data) => {
        if (data.RedirectToVerification) {
          this.router.navigate([
            "/engagement",
            this.engagementId,
            "remediation", //remediation
          ]);
        } else {
          this.router.navigate([
            "/engagement",
            this.engagementId,
            "mappingselection",
          ]);
        }
      });
  }
  previousButton() {
    this.confirmdisplay = false;
    this.router.navigate(["/engagement/", this.engagementId, "layout"]);
    this.sharedService.setactiveindex(0);
  }

  OkNotificationDisplay() {
    this.notificationDisplay = false;
  }

  endDateMismatchBtnClick() {
    const periodPreferenceModel = new PeriodPreferenceModel();
    periodPreferenceModel.EngagementId = this.engagementId;
    periodPreferenceModel.PeriodPreference =
      this.endDateBasedOnTemplate === "1";
    periodPreferenceModel.QueueIdentifier = 16; // Queueid for CapIQFromFlatfile

    if (periodPreferenceModel.PeriodPreference)
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnSourceFile
        )
        .subscribe();
    else
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnProjectInput
        )
        .subscribe();

    this.periodService.UpdatePeriodPreference(periodPreferenceModel).subscribe(
      () => {
        this.isEndDateMismatch = false;
        if (this.endDateBasedOnTemplate === "1") {
          this.notificationDisplay = true;
        } else {
          this.showNextButton = true;
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }
}
